import { ReactNode } from 'react';
import TwoSidebar from '../organisms/TwoSidebar';
import { ToastContainer } from 'react-toastify';

interface LayoutProps {
    children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
    return (
        <div className="flex min-h-screen bg-neutral text-text-primary dark:bg-slate-800">
            <TwoSidebar />
            <ToastContainer
                stacked={true}
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="flex-1 min-w-0 dark:text-white">{children}</div>
        </div>
    );
};

export default Layout;
